<div *ngIf="params.rowIndex==0 && (isSort || isFilter || isRefresh)" style="display: flex; flex-direction: row;align-items: center; padding-top: 15px;padding-left: 5px;">
    <mat-spinner diameter="20"></mat-spinner> &nbsp;&nbsp;
    Loading...
</div>
 <div *ngIf="!isSort && !isFilter && !isRefresh"  style="display: flex; flex-direction: row;align-items: center; padding-top: 15px;padding-left: 5px;">
    <mat-spinner diameter="20"></mat-spinner> &nbsp;&nbsp;
    Loading...
</div> 
